import React, { useEffect, useRef } from "react";
import clsx from "clsx";
import styles from "./styles.module.css";
import ImageComponent from "../../ImageComponent";
import { TOKEN_KILL_STEP_TIME } from "../constant";
import { getHeightCorrectedForIphone6, getWidth } from "../../../utils/relativeSizes";

interface IKukariKillAnimationProps {
  kukariImage: string;
  height: number;
  width: number;
  currentCoordinates?: { translateX: number; translateY: number };
  nextCoordinates?: { translateX: number; translateY: number };
}

const KukariKillAnimation: React.FC<IKukariKillAnimationProps> = ({
  currentCoordinates = { translateX: 0, translateY: 0 },
  nextCoordinates,
  kukariImage,
  height,
  width,
}) => {
  const kukariRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (nextCoordinates && kukariRef.current) {
      const kukariElement = kukariRef.current;
      // Apply animation styles
      kukariElement.style.transition = `transform ${TOKEN_KILL_STEP_TIME}ms linear`;
      kukariElement.style.transform = `translate(${nextCoordinates.translateX}px, ${nextCoordinates.translateY}px) scale(1.25)`;

      // Optional callback when the animation ends
      const handleAnimationEnd = () => {
        // Custom logic if needed after the animation completes
        console.log("Animation completed!");
      };

      kukariElement.addEventListener("transitionend", handleAnimationEnd);

      // Cleanup listener
      return () => {
        kukariElement?.removeEventListener("transitionend", handleAnimationEnd);
      };
    }
  }, [nextCoordinates]);

  return (
    <div
      ref={kukariRef}
      className={clsx(styles.kukariContainer)}
      style={{
        width: getWidth(21),
        height: getHeightCorrectedForIphone6(21),
        transform: `translate(${currentCoordinates.translateX}px, ${currentCoordinates.translateY}px)`,
        zIndex: 80
      }}
    >
      <ImageComponent
        src={kukariImage}
        alt="Kukari"
        style={{
          height: `${height}px`,
          width: `${width}px`,
          transform: `translate(0, -5px)`,
        }}
      />
    </div>
  );
};

export default React.memo(KukariKillAnimation);
